export default __webpack_public_path__ + "static/media/Request.1a842f66.svg";